import React from 'react'
import { IconButton, Table } from 'rsuite'
import Save from '@rsuite/icons/legacy/Save'
import Edit from '@rsuite/icons/legacy/Edit'
import Remove from '@rsuite/icons/legacy/Trash'


const { Column, HeaderCell, Cell } = Table

export const ActionCell = ({ rowData, dataKey, onEdit, ...props }) => {
  return (
    <Cell {...props} style={{ padding: '6px', display: 'flex', gap: '4px' }}>
      <IconButton
        appearance="subtle"
        icon={rowData.status === 'EDIT' ? <Save /> : <Edit />}
        onClick={() => {
          onEdit(rowData[dataKey])
        }}
      />
    </Cell>
  )
}